import { createApi } from "@reduxjs/toolkit/query/react";
import createBaseQuery from "./createBaseQuery";
export function createBLASTEndpointsApi(baseUrl) {
    const blastEndpointsApi = createApi({
        reducerPath: `blastEndpointsApi_${baseUrl}`,
        baseQuery: createBaseQuery(baseUrl),
        tagTypes: [
            "BLASTEndpoints"
        ],
        endpoints: (build)=>({
                getBLASTEndpoints: build.query({
                    query: ()=>({
                            url: "api/admin/blast-endpoints",
                            method: "GET"
                        }),
                    providesTags: [
                        "BLASTEndpoints"
                    ],
                    transformResponse: (response)=>response.endpoints
                }),
                createBLASTEndpoints: build.mutation({
                    query: (body)=>({
                            url: "api/admin/blast-endpoints",
                            method: "POST",
                            body
                        }),
                    invalidatesTags: [
                        "BLASTEndpoints"
                    ]
                }),
                updateBLASTEndpoint: build.mutation({
                    query: ({ id, address })=>({
                            url: `api/admin/blast-endpoints/${id}`,
                            method: "PUT",
                            body: {
                                address
                            }
                        }),
                    invalidatesTags: [
                        "BLASTEndpoints"
                    ]
                }),
                deleteBLASTEndpoint: build.mutation({
                    query: ({ id })=>({
                            url: `api/admin/blast-endpoints/${id}`,
                            method: "DELETE"
                        }),
                    invalidatesTags: [
                        "BLASTEndpoints"
                    ]
                })
            })
    });
    return blastEndpointsApi;
}
